import React from 'react';
import { Controller } from 'react-hook-form';

/**
 * BeDetailsTab — BE DETAILS tab
 * standard Bootstrap 5 horizontal form layout (col-5 label, col-7 input)
 * Uniform grid split ensures all input fields align perfectly at the same horizontal level.
 */
const BeDetailsTab = ({ control, errors }) => {
  return (
    <div className="w-100">
      <h5 className="de-section-title">BE DETAILS</h5>

      <div className="row g-3">
        {/* Row 1: BE NO, BE DATE, BE USD */}
        <div className="col-12 col-md-6 col-lg-4">
          <div className="row align-items-center g-2">
            <label className="col-5 col-form-label de-label text-start">BE NO :</label>
            <div className="col-7">
              <Controller
                name="beNo"
                control={control}
                render={({ field }) => (
                  <input {...field} type="text" className="form-control" placeholder="BE Number" />
                )}
              />
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6 col-lg-4">
          <div className="row align-items-center g-2">
            <label className="col-5 col-form-label de-label text-start">BE DATE :</label>
            <div className="col-7">
              <Controller
                name="beDate"
                control={control}
                render={({ field }) => (
                  <input
                    type="date"
                    className="form-control"
                    value={field.value || ''}
                    onChange={(e) => field.onChange(e.target.value)}
                  />
                )}
              />
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6 col-lg-4">
          <div className="row align-items-center g-2">
            <label className="col-5 col-form-label de-label text-start">BE USD :</label>
            <div className="col-7">
              <Controller
                name="beUsd"
                control={control}
                render={({ field }) => (
                  <input {...field} type="number" className="form-control" placeholder="BE USD" />
                )}
              />
            </div>
          </div>
        </div>

        {/* Row 2: DUTY PAYMENT DATE, CUSTOMS DUTY, SOCIAL WELFARE CHARGE */}
        <div className="col-12 col-md-6 col-lg-4">
          <div className="row align-items-center g-2">
            <label className="col-5 col-form-label de-label text-start text-uppercase">Duty Payment Date :</label>
            <div className="col-7">
              <Controller
                name="dutyPaymentDate"
                control={control}
                render={({ field }) => (
                  <input
                    type="date"
                    className="form-control"
                    value={field.value || ''}
                    onChange={(e) => field.onChange(e.target.value)}
                  />
                )}
              />
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6 col-lg-4">
          <div className="row align-items-center g-2">
            <label className="col-5 col-form-label de-label text-start">CUSTOMS DUTY :</label>
            <div className="col-7">
              <Controller
                name="customDuty"
                control={control}
                render={({ field }) => (
                  <input
                    {...field}
                    type="number"
                    className="form-control"
                    placeholder="Custom Duty"
                  />
                )}
              />
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6 col-lg-4">
          <div className="row align-items-center g-2">
            <label className="col-5 col-form-label de-label text-start">SOCIAL WELFARE CHARGE :</label>
            <div className="col-7">
              <Controller
                name="socialWelfareCharges"
                control={control}
                render={({ field }) => (
                  <input
                    {...field}
                    type="number"
                    className="form-control"
                    placeholder="Social Welfare Charges"
                  />
                )}
              />
            </div>
          </div>
        </div>

        {/* Row 3: BE IGST, ASSESS VALUE */}
        <div className="col-12 col-md-6 col-lg-4">
          <div className="row align-items-center g-2">
            <label className="col-5 col-form-label de-label text-start">BE IGST :</label>
            <div className="col-7">
              <Controller
                name="beIgst"
                control={control}
                render={({ field }) => (
                  <input {...field} type="number" className="form-control" placeholder="BE IGST" />
                )}
              />
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6 col-lg-4">
          <div className="row align-items-center g-2">
            <label className="col-5 col-form-label de-label text-start">ASSESS VALUE :</label>
            <div className="col-7">
              <Controller
                name="assessValue"
                control={control}
                render={({ field }) => (
                  <input {...field} type="number" className="form-control" placeholder="Assess Value" />
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BeDetailsTab;
